import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FieldableSchema = withDefaults({
  type: 'fieldable',
  fields: [
    {
      kind: 'hasMany',
      name: 'tasFields',
      type: 'tas-field',
      options: {
        async: false,
        inverse: null,
        as: 'fieldable',
      },
    },
  ],
});

export default FieldableSchema;
